var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFileThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1169_43186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1307 11.7588L31.5137 14.9393H0.486328L2.86931 11.7588",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1307 11.7588L31.5137 14.9393H0.486328L2.86931 11.7588",
    stroke: "#222222",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1305 9.63891V32.3113H2.86914V0.486328H19.5792L29.1305 9.63891Z",
    fill: "white",
    stroke: "#222222",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1305 9.63891H19.5791V0.486328L29.1305 9.63891Z",
    fill: "#E6E6E6",
    stroke: "#222222",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5137 14.9688H0.486328V29.2861H31.5137V14.9688Z",
    fill: "#929DAE",
    stroke: "#222222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2973 22.9339V23.2765H19.5592C19.5961 24.3646 20.2309 24.9625 21.1478 24.9625C21.7658 24.9625 22.1554 24.6938 22.3434 24.3714H23.2167C22.9749 25.1573 22.2091 25.6879 21.1478 25.6879C19.6566 25.6879 18.7363 24.6266 18.7363 23.0414C18.7363 21.4561 19.67 20.3545 21.0672 20.3545C22.1554 20.3545 23.2973 21.0195 23.2973 22.9339ZM19.5592 22.5779H22.4644C22.4644 21.7181 21.9203 21.0799 21.0739 21.0799C20.1772 21.0799 19.6129 21.7852 19.5592 22.5779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.957 18.7021H17.7765V25.5805H16.957V18.7021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3521 19.5686C15.0364 19.5686 14.7744 19.3268 14.7744 19.0246C14.7744 18.7223 15.0364 18.4805 15.3521 18.4805C15.6611 18.4805 15.923 18.7223 15.923 19.0246C15.923 19.3268 15.6611 19.5686 15.3521 19.5686ZM15.7551 25.5805H14.9356V20.4217H15.7551V25.5805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5796 25.5805H9.72656V18.7021H13.8643V19.4612H10.5796V21.7585H13.5553V22.5108H10.5796V25.5805Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1169_43186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32.7976,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileThumb);
export default __webpack_public_path__ + "static/media/ico-file-thumb.bda327e0ef4704218ec3eb26c9b5698e.svg";
export { ForwardRef as ReactComponent };